import { EntityDocumentsOrderBy } from "common/types/globalTypes";

export enum OrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export interface SortOrder {
  column: string;
  direction: OrderDirection;
}
export type OrderLookup = {
  [direction in OrderDirection]: EntityDocumentsOrderBy[];
};

